import React from 'react';
import PropTypes from 'prop-types';
import { decode } from 'html-entities';
import { DisplayControl } from './controls';

const LessonItem = ({ lesson, updateSettings, getOptionValue, solutionTypes }) => {
  return (
    <div className="item-container">
      <h4 className="item-heading">{decode(lesson.title)}</h4>
      <div className="solution-types-container">
        <div className="solution-types-row">
          {solutionTypes.map((type) => (
            <div className="solution-type-item" key={type.id}>
              <span className="type-label">{type.name}</span>
              <DisplayControl
                value={getOptionValue('lesson', lesson.id, type.id)}
                onChange={(value) => updateSettings('lesson', lesson.id, type.id, value)}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

LessonItem.propTypes = {
  lesson: PropTypes.object.isRequired,
  updateSettings: PropTypes.func.isRequired,
  getOptionValue: PropTypes.func.isRequired,
  solutionTypes: PropTypes.array.isRequired,
};

export default LessonItem;
